import { render, staticRenderFns } from "./ControlAssistantPage.vue?vue&type=template&id=7555b9e4&scoped=true"
import script from "./ControlAssistantPage.vue?vue&type=script&lang=js"
export * from "./ControlAssistantPage.vue?vue&type=script&lang=js"
import style0 from "./ControlAssistantPage.vue?vue&type=style&index=0&id=7555b9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7555b9e4",
  null
  
)

export default component.exports